export const clearLocalStoragePreferences = () => {
	// Clear job dashboard preferences.
	localStorage.removeItem('rome:job-dashboard:tab');
	localStorage.removeItem('rome:job-dashboard:temp-settings');

	// Clear search data table preferences.
	localStorage.removeItem('rome:search-data-table:saved-ids');

	// Clear notification preferences.
	localStorage.removeItem('rome:notification:push');

	// Clear legacy preferences.
	localStorage.removeItem('rome:dashboard:listType');
	localStorage.removeItem('rome:dashboard:settings');
	localStorage.removeItem('rome:dashboard:savedId');
	localStorage.removeItem('rome:job-dashboard:saved-id');
};
